import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import { fetchRestaurantUserListAsync } from './restaurantUserListSlice';
import { RestaurantUserFormData } from '../../../app/data/models/restaurantUsers/restaurantUserFormdata';

export interface CreateRestaurantUserState {
  status: string;
  dismiss: boolean;
}

const initialState: CreateRestaurantUserState = {
  status: 'idle',
  dismiss: false,
};

export const createRestaurantUserAsync = createAsyncThunk<
  void,
  { restaurantId: string; data: RestaurantUserFormData },
  { rejectValue: { error: string } }
>('restaurantUsers/create', async ({ restaurantId, data }, thunkApi) => {
  try {
    await api.RestaurantUser.create(restaurantId, data);
    thunkApi.dispatch(fetchRestaurantUserListAsync({ restaurantId }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    return thunkApi.rejectWithValue({ error: error.data });
  }
});

export const createRestaurantUserSlice = createSlice({
  name: 'createRestaurantUser',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createRestaurantUserAsync.pending, (state) => {
      state.status = 'pendingCreateRestaurantUser';
    });
    builder.addCase(createRestaurantUserAsync.fulfilled, (state) => {
      state.status = 'idle';
      state.dismiss = true;
    });
    builder.addCase(createRestaurantUserAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
